import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { canbyConfig } from "./data";

export default function CanbyPage() {
  return <OregonCityPageTemplate config={canbyConfig} />;
}